import { motion } from "framer-motion";

const STATS = [
    {
        v: "₹15,000 Cr",
        k: "Indian MSME exports at CBAM exposure by 2028",
        src: "Ministry of Commerce · CBAM notification"
    },
    {
        v: "€85 / t",
        k: "CBAM default emissions price, 2026 onwards",
        src: "European Commission · Reg. 2023/956"
    },
    {
        v: "6–11×",
        k: "Scope 3 as a multiple of Scope 1+2 for Indian mid-market industry",
        src: "Carbonis Research Desk"
    },
    {
        v: "70%",
        k: "of India's export economy anchored by MSMEs — the least-lit part of the balance sheet",
        src: "MoMSME Annual Report"
    }
];

export default function ProofBar() {
    return (
        <section
            className="relative border-y border-navy/10 bg-navy/[0.02]"
            data-testid="section-proof-bar"
        >
            <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-10 lg:py-14">
                <div className="flex items-center gap-4 mb-8">
                    <div className="w-10 h-px bg-gold"></div>
                    <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold">
                        The Market — In Numbers
                    </span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-10">
                    {STATS.map((s, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.7, delay: i * 0.08 }}
                            className="border-l border-navy/15 pl-6"
                            data-testid={`proof-stat-${i}`}
                        >
                            <div className="font-serif text-4xl lg:text-5xl leading-[1] tracking-[-0.02em] text-navy">
                                {s.v}
                            </div>
                            <p className="mt-3 text-navy/70 text-sm leading-relaxed max-w-[240px]">
                                {s.k}
                            </p>
                            <div className="mt-4 font-mono text-[10px] tracking-[0.18em] uppercase text-navy/40">
                                {s.src}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
